<script>
/**
     * @overview 全局选择文件组件
     *
     * @author huojinzhao
     */

import MaterialReview from "./index.vue";

export default {
  name: "FileBox",

  components: {
    MaterialReview,
  },
  props: {
    type: {
      type: String,
      default: "",
    },
    // 是否是zip格式路径输出
    isZip: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    innerVisible: false,
    randomID: Math.floor(Math.random() * (10 ** 10)),
  }),

  computed: {
    inputID() {
      return `app-create-file__input-${this.randomID}`;
    },
  },

  methods: {
    success(val) {
      this.innerVisible = false;
      let newVal = val;
      // 如果是动画2的zip文件把后缀去掉
      if (this.isZip && newVal.indexOf('.zip') !== -1) {
        newVal = newVal.replace('.zip', '');
      }
      this.$emit("success", newVal);
    },
    showDialog() {
      this.innerVisible = true;
    },
    cancel() {
      this.innerVisible = false;
    },
  },
};
</script>

<template>
  <div class="dialog">
    <el-dialog
      :visible.sync="innerVisible"
      width="80%"
      title="选择素材"
      append-to-body
    >
      <MaterialReview
        v-if="innerVisible"
        :id="type"
        @success="success"
        @cancel="cancel" />
    </el-dialog>
    <AppLabel
      :width="$attrs.width"
      :height="$attrs.height"
      class="app-create-file"
    >
      <input
        v-show="false"
        slot="file"
        ref="input"
        :id="inputID"
        @click="showDialog"
      >
      <!-- eslint-disable-next-line -->
            <slot slot="placeholder" name="placeholder" />
    </AppLabel>
  </div>
</template>

<style lang="postcss">
    .app-create-file {

    }
    .dialog{
        width: auto;
        display: inline-block;
        vertical-align: middle;
        height: 100%;
    }
</style>
